import {MessageDescriptor} from 'react-intl';
import {ReactNode} from 'react';

import {StripeAssistantDrawerHeader} from './StripeAssistantDrawerHeader';
import {StripeAssistantWidgetHeader} from './StripeAssistantWidgetHeader';
import {useHasFlag} from '../../../core/hooks/appHooks';

type Props = {
  title?: MessageDescriptor;
  height?: number | string;
  badge?: ReactNode;
  headerActions?: ReactNode;
  subHeader?: ReactNode;
};

export function StripeAssistantHeader(props: Props) {
  const universalHelpDrawerEnabled = useHasFlag('universalHelpDrawerEnabled');

  if (universalHelpDrawerEnabled) {
    return <StripeAssistantDrawerHeader {...props} />;
  }

  return <StripeAssistantWidgetHeader {...props} />;
}
